// src/components/auth/AuthCallback.jsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import storageHelper from '../../utils/storageHelper';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = () => {
      try {
        // Get token from URL query parameters
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
          console.error('Authentication failed: No token received');
          navigate('/', { replace: true });
          return;
        }

        // Save token to localStorage
        // localStorage.setItem('authToken', token);
        storageHelper.set('authToken', token);

        // Remove token from URL and redirect to dashboard
        window.history.replaceState({}, document.title, '/dashboard');
        console.log('Successfully logged in!');

        // Navigate to dashboard without the token in URL
        navigate('/dashboard', {
          replace: true,
          state: { authenticated: true }
        });
      } catch (error) {
        console.error('Auth callback error:', error);
        console.error('Authentication failed');
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate, location]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-800"></div>
    </div>
  );
};

export default AuthCallback;
